<script>
    import AssetsApi from '../../routes/asset/assets.api.js';

    let {
        value,
        rowIndex,
        rowId,
        instructKey
    } = $props();

    let triggerAnimation = $state(false);

    const updateEachBlock = (value)=>{
        if(!value) return "";
        let content = []
        if(value[instructKey].length){
            for(let val of value[instructKey]){
                if(val) content.push(val);
            }
        }
        return content;
    }

    let data = $derived(updateEachBlock(value));
    let rowIdx = $derived(rowIndex);
    let key    = $derived(instructKey);
</script>


{#if data.length > 0 && data.length == 1}
    {#each data as item, idx}
        <div>
            <a href={"/" + key + "/" + (key === 'asset' ? item.kind + "/" : "") + item.id}>{item.name || item.title_es || item.title}</a>
        </div>
        {#if value && value.loader.loading || !value}
            <div style="width: 24px; cursor: pointer;"><i class="fas fa-sync-alt fa-spin"></i></div>
        {/if}
    {/each}
{:else if data.length > 1}
    <div class="">
            <a href={"/" + key + "/" + (key === 'asset' ? data[0].kind + "/" : "") + data[0].id}>{data[0].name || data[0].title_es || data[0].title}</a>
        {#if key === 'asset'}
            <i class={AssetsApi.AssetsIcons[data[0].kind]}></i>
        {/if}
    </div>
    <div id={"collapseTd" + key + rowId} class="collapse">
        {#each data as item, index}
            {#if index > 0}
                <div class="">
                                        <a href={"/" + key + "/" + (key === 'asset' ? item.kind + "/" : "") + item.id}>{item.name || item.title_es || item.title}</a>
                    {#if key === 'asset'}
                        <i class={AssetsApi.AssetsIcons[item.kind]}></i>
                    {/if}
                </div>
            {/if}
        {/each}
    </div>
    {#if value && value.loader.loading || !value}
        <div style="width: 24px; cursor: pointer;"><i class="fas fa-sync-alt fa-spin"></i></div>
    {:else}
        <div id="dropdownButton" style="width: 24px; cursor: pointer;" data-bs-toggle="collapse" data-bs-target={"#collapseTd" + key + rowId} onclick={()=>triggerAnimation = !triggerAnimation}>
            <i class="fas fa-chevron-down chevron-button" class:chevron-animation={triggerAnimation}></i>
        </div>
    {/if}
{:else}
    <div>
        {#if value && value.loader.loading || !value}
            <i class="fas fa-sync-alt fa-spin"></i>
        {/if}
    </div>
{/if}
